/**
 * jxScrollbarThin — shared thin scrollbar class name, same pattern as tooltipSx/jernyTooltipStyling.
 * Add to any scrollable element's className alongside its own class:
 *   className={`jx-note-editor-body ${jxScrollbarThin}`}
 * Styling itself lives in JxTheme.css (.jx-scrollbar-thin) — this export is just the
 * single source of truth for the class name so it's never typo'd/duplicated per component.
 */
export const jxScrollbarThin = 'jx-scrollbar-thin';
